import { IRootState } from "../../../../redux/rootReducer"


export const filterMapState = (state: IRootState) => {
    return {
        filter: state.filterChart
    }
}